import { RedmptionRelatedQuestions } from './redemptionRelatedQuestions'

export { RedmptionRelatedQuestions }
